import * as Notifications from 'react-notification-system';

export class NotificationService {
    public notificationSystem: Notifications.System;

    constructor(notificationSystem: Notifications.System) {
        this.notificationSystem = notificationSystem;

        this.addNotification = this.addNotification.bind(this);
    }

    public isAvailable(): boolean {
        return this.notificationSystem ? true : false;
    }

    public addNotification(message: string): void {
        this.notificationSystem.addNotification({
            message: message,
            level: 'success',
        });
    }

    public addError(message: string): void {
        this.notificationSystem.addNotification({
            message: message,
            level: 'error',
        });
    }

    public addWarning(message: string): void {
        this.notificationSystem.addNotification({
            message: message,
            level: 'warning',
        });
    }

    public addInfo(message: string): void {
        this.notificationSystem.addNotification({
            message: message,
            level: 'info',
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/notifications/NotificationService.tsx